export const SECTION = Object.freeze({
  SHOP_DASHBOARD: "shop-dashboard",
  USER_ACCOUNT: "user-account",
  ADMIN_ORDERS: "admin-orders",
  ADMIN_CONTENT: "admin-content",
  ADMIN_USERS: "admin-users",
  ADMIN_MARKETING: "admin-marketing",
  ADMIN_SYSTEM: "admin-system",
  UTILITY: "utility",
});

export const SECTION_ORDER = Object.freeze([
  SECTION.SHOP_DASHBOARD,
  SECTION.USER_ACCOUNT,
  SECTION.ADMIN_ORDERS,
  SECTION.ADMIN_CONTENT,
  SECTION.ADMIN_USERS,
  SECTION.ADMIN_MARKETING,
  SECTION.ADMIN_SYSTEM,
  SECTION.UTILITY,
]);
